import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

function renderInlineMarkdown(text) {
  const parts = String(text || "").split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, idx) => {
    if (part.startsWith("**") && part.endsWith("**") && part.length > 4) {
      return <strong key={`b-${idx}`}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={`t-${idx}`}>{part}</React.Fragment>;
  });
}

function renderMarkdownTerms(markdown) {
  const lines = String(markdown || "")
    .split(/\r?\n/)
    .map((line) => line.trim());

  const blocks = [];
  let listItems = [];

  const flushList = () => {
    if (listItems.length === 0) return;
    blocks.push(
      <ul key={`ul-${blocks.length}`} className="mb-2 ps-3">
        {listItems.map((item, idx) => (
          <li key={`li-${idx}`}>{renderInlineMarkdown(item)}</li>
        ))}
      </ul>
    );
    listItems = [];
  };

  lines.forEach((line) => {
    if (!line) {
      flushList();
      return;
    }
    if (line === "---") {
      flushList();
      blocks.push(<hr key={`hr-${blocks.length}`} className="my-2" />);
      return;
    }
    if (line.startsWith("- ")) {
      listItems.push(line.slice(2));
      return;
    }
    flushList();
    if (line.startsWith("### ")) {
      blocks.push(
        <div key={`h3-${blocks.length}`} className="fw-semibold mt-2 mb-1">
          {renderInlineMarkdown(line.slice(4))}
        </div>
      );
      return;
    }
    if (line.startsWith("## ")) {
      blocks.push(
        <div key={`h2-${blocks.length}`} className="fw-bold mb-2">
          {renderInlineMarkdown(line.slice(3))}
        </div>
      );
      return;
    }
    blocks.push(
      <p key={`p-${blocks.length}`} className="mb-2">
        {renderInlineMarkdown(line)}
      </p>
    );
  });

  flushList();
  return blocks;
}

export default function WarrantyTermsModal({
  isOpen,
  terms,
  onClose,
  emptyText = "Terms are not available.",
}) {
  const markdownText = String(terms || "").trim();

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="md">
      <ModalHeader toggle={onClose}>Warranty terms</ModalHeader>
      <ModalBody>
        {markdownText ? (
          <div>{renderMarkdownTerms(markdownText)}</div>
        ) : (
          <div className="text-muted">{emptyText}</div>
        )}
      </ModalBody>
    </Modal>
  );
}

